module.exports = __webpack_public_path__ + "static/assets/33152e09f092ce18fe776f1d670ac99f.svg";